import React, { useState, useEffect } from "react";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Ridersorder = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("current");
  const [ordersData, setOrdersData] = useState({
    current: [],
    completed: [],
    pending: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  let id = null;
  try {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      id = decoded.id || decoded._id;
    }
  } catch (err) {
  
    setError("Authentication error. Please log in again.");
  }

  const limit = 20;

  useEffect(() => {
    const fetchOrders = async () => {
      if (!id) return;
      try {
        setLoading(true);
        setError("");
        const res = await api.Getriderorders(id, page, limit);
        if (res?.data) {
          setOrdersData({
            current: res.data.current || [],
            completed: res.data.completed || [],
            pending: res.data.pending || [],
          });
          setTotalPages(res.data.pagination?.pages || 1);
        } else {
          setOrdersData({ current: [], completed: [], pending: [] });
          setTotalPages(1);
        }
      } catch (err) {
  
        setError("Failed to fetch orders. Please try again.");
        setOrdersData({ current: [], completed: [], pending: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [id, page]);

  const renderOrders = (orders) => (
    <div className="space-y-4 mt-4">
      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : orders.length === 0 ? (
        <p className="text-gray-500">No orders found.</p>
      ) : (
        orders.map((order) => (
          <div
            key={order._id || order.id}
            className="p-4 bg-white shadow rounded-lg border border-gray-200 flex justify-between items-center"
          >
            <div>
              <h3 className="font-semibold text-lg">{order.item}</h3>
              <p className="text-sm text-gray-500">{order.status}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto w-full">
        {/* Back button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700 hover:text-orange-600 mb-4"
        >
          <IoMdArrowBack size={24} />
          <span className="ml-1">Back</span>
        </button>

        <h1 className="text-2xl font-bold mb-6 text-gray-800">My Orders</h1>

        {/* Tabs */}
        <div className="overflow-x-auto">
          <div className="flex space-x-4 border-b border-gray-200 min-w-max">
            {["current", "completed", "pending"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-2 px-4 ${
                  activeTab === tab
                    ? "border-b-2 border-teal-500 text-teal-500 font-semibold"
                    : "text-gray-500 hover:text-teal-500"
                }`}
              >
                {tab === "current"
                  ? "Current Orders"
                  : tab === "completed"
                  ? "Completed Orders"
                  : "Pending Approval"}
              </button>
            ))}
          </div>
        </div>

        {/* Orders */}
        {activeTab === "current" && renderOrders(ordersData.current)}
        {activeTab === "completed" && renderOrders(ordersData.completed)}
        {activeTab === "pending" && renderOrders(ordersData.pending)}

        {/* Pagination */}
        <div className="flex justify-center items-center mt-6 space-x-4">
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Previous
          </button>
          <span className="text-gray-600">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            disabled={page === totalPages}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Ridersorder;
